import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import InputMask from 'react-input-mask'

const Index = (props) => {
  const {
    boxSx,
    id,
    name,
    maskChar,
    mask,
    placeholder,
    labelText,
    required,
    disabled,
    onChange,
    textError,
    value,
    isShowTextError = true,
    testId,
  } = props

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', width: '100%', ...boxSx }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography
          variant="body2"
          color={disabled ? 'text.gray' : 'text.secondary'}
        >
          {labelText}
        </Typography>
        {required && (
          <Typography
            sx={{ lineHeight: 1, ml: 0.5 }}
            color={disabled ? 'text.gray' : 'error'}
          >
            *
          </Typography>
        )}
      </Box>
      <InputMask
        id={id}
        name={name}
        maskChar={maskChar}
        mask={mask}
        onChange={onChange}
        value={value}
      >
        {() => (
          <TextField
            placeholder={disabled ? '' : placeholder}
            inputProps={{
              'data-testid': testId,
              disabled: disabled,
            }}
            sx={{ backgroundColor: disabled && '#F5F5F5' }}
          />
        )}
      </InputMask>

      {isShowTextError && (
        <Typography sx={{ height: '25px' }} variant="body2" color="error">
          {textError}
        </Typography>
      )}
    </Box>
  )
}
export default Index
